<template>
    <div>
        <h3>Server Configuration <span v-if="service.custom.Location" class="sau-font">- {{ service.custom.Location }}</span></h3>
        <div class="row pb-6">
            <div class="col">
                <div class="sau-bx bx-pad">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <ul class="sau-list-display">
                                <li v-for="(val, key) in this.col1" :key="key">
                                    <h5>{{ val[0] }}</h5>
                                    <p>{{ val[1] }}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <ul class="sau-list-display">
                                <li v-for="(val, key) in this.col2" :key="key">
                                    <h5>{{ val[0] }}</h5>
                                    <p>{{ val[1] }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <licensing></licensing>

        <h3>Network -
            <span class="sau-font sm text-center">
                <i class="fas fa-link sau-font-color blue"></i>
                <a :href="networkLink">View Network Usage</a>
            </span>
        </h3>
        <div class="row">
            <div class="col">
                <div class="sau-bx bx-pad">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <ul class="sau-list-display">
                                <li>
                                    <h5>Primary IP Address</h5>
                                    <p> {{ service.ipaddress }}</p>
                                </li>
                                <li>
                                    <h5>Netmask</h5>
                                    <p>{{ displayValue('subnet_mask') }}</p>
                                </li>
                                <li v-if="service.custom.Bandwidth">
                                    <h5>Data Quota</h5>
                                    <p>{{ service.custom.Bandwidth }}</p>
                                </li>
                                <li v-if="service.custom.Quota">
                                    <h5>Quota</h5>
                                    <p>{{ service.custom.Quota }}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <ul class="sau-list-display">
                                <li>
                                    <h5>Additional IP Addresses</h5>
                                    <p v-if="ips.length">
                                        <template v-for="additional in ips">
                                            {{ additional }}
                                        </template>
                                    </p>
                                    <p v-else>Not Set</p>
                                </li>
                                <li>
                                    <h5>Gateway</h5>
                                    <p>{{  displayValue('gateway') }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Licensing from '../Licensing';
export default {
    components: {
        'licensing': Licensing,
    },
    props: ['service'],
    data() {
        return {
            specificFields: [
                'Location',
                'Bandwidth',
                'Quota'
            ],
            renameFields: {
                DC: 'Data Center'
            },
            filtered: [],
            formatted: [],
            col1: [],
            col2: [],
            ips: ''
        }
    },
    created() {
        this.formatDetails();
    },
    methods: {
        formatDetails() {
            let x = 1;
            _.forIn(this.service.custom, function(val, key) {
                if(!this.specificFields.includes(key)) {
                    if(x % 2) {
                        this.col1.push([key, val]);
                    } else {
                        this.col2.push([key, val]);
                    }
                    x++;
                }
            }.bind(this));
            this.formatted = _.chunk(this.filtered, Math.ceil(this.filtered.length / 2));
            this.ips = this.service.assignedips ? this.service.assignedips.split(" ") : '';
        },
        displayValue(field) {
            if(!this.service['network']) {
                return 'Not Set';
            }
            return this.service['network'][field] ? this.service['network'][field] : 'Not Set';
        },
        specificField(field) {
            return this.specificFields.includes(field);
        }
    },
    computed: {
        ipAddress() {
            /**
             * Return DedicatedIP : ServerIP : ServerHostName : 'Not Set'
             */
            return this.service['dedicatedip'] ? this.service['dedicatedip'] : this.service['serverip'] ? this.service['serverip'] : this.service['serverhostname'] ? this.service['serverhostname'] : 'Not Set';
        }
    }
}
</script>

<style>
</style>
